import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

import './zzz-element.scss';

interface IProps {
  style: string;
  notext?: boolean;
}

export const ZZZStyle: React.FC<IProps> = ({ style, notext }) => {
  return (
    <div className={`zzz-style ${style}`}>
      {style === 'Anomaly' && (
        <>
          <StaticImage
            src="../../../../images/zzz/icons/style_anomaly.png"
            alt={style}
          />
          {notext ? <></> : <span>{style}</span>}
        </>
      )}
      {style === 'Attack' && (
        <>
          <StaticImage
            src="../../../../images/zzz/icons/style_attack.png"
            alt={style}
          />
          {notext ? <></> : <span>{style}</span>}
        </>
      )}
      {style === 'Defence' && (
        <>
          <StaticImage
            src="../../../../images/zzz/icons/style_defence.png"
            alt={style}
          />
          {notext ? <></> : <span>{style}</span>}
        </>
      )}
      {style === 'Stun' && (
        <>
          <StaticImage
            src="../../../../images/zzz/icons/style_stun.png"
            alt={style}
          />
          {notext ? <></> : <span>{style}</span>}
        </>
      )}
      {style === 'Support' && (
        <>
          <StaticImage
            src="../../../../images/zzz/icons/style_support.png"
            alt={style}
          />
          {notext ? <></> : <span>{style}</span>}
        </>
      )}
      {style === 'Rupture' && (
        <>
          <StaticImage
            src="../../../../images/zzz/icons/style_rupture.png"
            alt={style}
          />
          {notext ? <></> : <span>???</span>}
        </>
      )}
    </div>
  );
};
